/* eslint-disable import/no-duplicates */
import RawPCMSpeechProcessorUrl from './RawPCMSpeech.processor?worker&url';
import RawPCMSpeechProcessorUrlDev from './RawPCMSpeech.processor?url';

export const getRawPCMSpeechProcessorUrl = (): string => {
  return import.meta.env.PROD ? RawPCMSpeechProcessorUrl : RawPCMSpeechProcessorUrlDev;
};
